import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'mdn-polyfills/String.prototype.repeat'
import './index.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import UAParser from 'ua-parser-js'
import store from './redux'
import App from './components'
import * as serviceWorker from './registerServiceWorker'
import { Toaster } from 'sonner'
import ErrorMessage from './components/common/ErrorMessage'
import { set as setTheme } from './theme'
import { BugsnagErrorBoundary } from './tracking/trackingScripts'

setTheme()

const browserParser = new UAParser()
const browser = browserParser.getBrowser().name

browser !== 'IE' && serviceWorker.unregister()

const containerElement = document.getElementById('root')
const reactRoot = createRoot(containerElement)

reactRoot.render(
  <Provider store={store}>
    <Toaster
      position="bottom-left"
      expand={true}
      richColors={false}
      closeButton={true}
      theme="light"
      toastOptions={{
        style: { 
          background: 'white',
          color: 'black',
          border: '1px solid #e2e8f0',
          maxWidth: '500px',
          width: '100%'
        },
        className: 'my-toast-class',
      }}
      style={{ zIndex: 999999999 }}
    />
    <BugsnagErrorBoundary FallbackComponent={ErrorMessage}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </BugsnagErrorBoundary>
  </Provider>,
  containerElement,
)
